/* @flow */
import produce from 'immer'

export default function reducer(
  state,
  action: any
) {
  const initialState = action.__initialData.defaultProps
  return produce(state, draft => {
    switch (action.type) {
      case 'CHANGE_TITLE':
        draft.title = action.value
        break
      case 'CHANGE_PARAGRAPH':
        draft.paragraph = action.value
        break
      case 'CHANGE_TITLE_ALIGNMENT': {
        draft.titleAlignment = action.value
        break
      }
      case 'CHANGE_PARAGRAPH_ALIGNMENT': {
        draft.paragraphAlignment = action.value
        break
      }
      case 'CHANGE_BLOCK_TITLE': {
        const { title, idx } = action.value
        draft.steps[idx].stepHeading = title
        break
      }
      case 'CHANGE_BLOCK_PARAGRAPH':
        const { paragraph, idx } = action.value
        draft.steps[idx].stepDescription = paragraph
        break
      case 'CHANGE_STEP_DESCRIPTION_ALIGNMENT': {
        const { alignment, idx } = action.value
        draft.steps[idx].stepDescriptionAlignment = alignment
        break
      }
      case 'ADD_BLOCK':
        draft.steps.push(initialState.steps[0])
        break
      case 'REMOVE_BLOCK':
        draft.steps.splice(action.value.idx, 1)
        break
      case 'CHANGE_ICON': {
        const { idx, iconName } = action.value
        draft.steps[idx].icon = iconName
        break
      }
      case 'REMOVE_BACKGROUND_IMAGE':
        draft.backgroundImgUrl = ''
        draft.backgroundImgDimensions = {}
        break
      case 'CHANGE_BACKGROUND_IMAGE':
        const { url, dimensions } = action.value
        draft.backgroundImgUrl = url
        draft.backgroundImgDimensions = dimensions
        break
      case 'CHANGE_BG_OVERLAY_TRANSPARENCY':
        draft.bgOverlayTransparency = action.value
        break
    }
  })
}
